import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.4 9.56a1.78 1.78 0 0 1 0-3 .75.75 0 0 0 .25-1l-1.19-2a.77.77 0 0 0-1-.3 1.75 1.75 0 0 1-1.15.13 1.78 1.78 0 0 1-1.38-1.7.75.75 0 0 0-.75-.69H6.82a.75.75 0 0 0-.75.69v.25A1.8 1.8 0 0 1 3.9 3.31a1.87 1.87 0 0 1-.4-.13.77.77 0 0 0-1 .31l-1.19 2a.76.76 0 0 0 .26 1 1.79 1.79 0 0 1 0 3.05.75.75 0 0 0-.26 1l1.18 2a.75.75 0 0 0 1 .3 1.76 1.76 0 0 1 1.13-.14 1.78 1.78 0 0 1 1.41 1.56.76.76 0 0 0 .75.68h2.41a.76.76 0 0 0 .75-.67 1.37 1.37 0 0 1 0-.19 1.81 1.81 0 0 1 2.1-1.39l.45.15a.74.74 0 0 0 1-.3l1.19-2a.77.77 0 0 0-.28-.98Zm-4.26-1.51A2.15 2.15 0 1 1 8 5.9a2.14 2.14 0 0 1 2.14 2.15Z';
const draw24px =
  'M21.74,14.77A3.23,3.23,0,0,1,20.3,11.4a3.2,3.2,0,0,1,1.44-2.06.75.75,0,0,0,.25-1L20.14,5.16a.76.76,0,0,0-1-.3,3.2,3.2,0,0,1-4.58-2.68.75.75,0,0,0-.75-.7H10.17a.75.75,0,0,0-.75.67,4.13,4.13,0,0,1-.07.49A3.22,3.22,0,0,1,5.56,5.11a3.09,3.09,0,0,1-.71-.24.76.76,0,0,0-1,.3L2,8.31a.76.76,0,0,0,.26,1,3.21,3.21,0,0,1,1.45,3.4,3.2,3.2,0,0,1-1.45,2,.75.75,0,0,0-.25,1L3.87,19a.75.75,0,0,0,1,.3A3.19,3.19,0,0,1,9.4,21.81a.76.76,0,0,0,.75.67h3.71a.75.75,0,0,0,.75-.7,1.45,1.45,0,0,1,0-.29A3.21,3.21,0,0,1,18.47,19a2.67,2.67,0,0,1,.69.23.75.75,0,0,0,1-.3L22,15.79A.77.77,0,0,0,21.74,14.77Zm-6.49-2.71A3.25,3.25,0,1,1,12,8.81,3.26,3.26,0,0,1,15.25,12.06Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const GearFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'gearFilled'),
) as IconWithRender;

GearFilledIcon.displayName = 'GearFilledIcon';
GearFilledIcon.propTypes = Icon.propTypes;
GearFilledIcon.renderIcon = (props) => <GearFilledIcon {...props} />;
export default GearFilledIcon;
